/**
 * @generated SignedSource<<3e57795a33c752fdcca1bdba40904358>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
export type AutoRecordRuleType = "RECORD" | "RESTRICT";
export type FilterAttendeeType = "EXTERNAL_ONLY" | "INTERNAL_AND_EXTERNAL" | "INTERNAL_ONLY";
export type DevMenuAutoRecordEventDataQuery$variables = {};
export type DevMenuAutoRecordEventDataQuery$data = {
  readonly viewer: {
    readonly devMenuAutoRecordEventData: ReadonlyArray<{
      readonly event: {
        readonly start: string | null;
        readonly title: string;
      };
      readonly record: boolean | null;
      readonly rule: {
        readonly autoRecordRuleUsers: ReadonlyArray<{
          readonly includeAllReports: boolean;
          readonly user: {
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
          };
        }>;
        readonly filterAttendeeType: FilterAttendeeType;
        readonly filterKeywordsContains: ReadonlyArray<string | null> | null;
        readonly filterKeywordsRestrict: ReadonlyArray<string | null> | null;
        readonly filterMaximumAttendees: number | null;
        readonly filterMinimumAttendees: number | null;
        readonly ruleLevel: AutoRecordRuleLevel;
        readonly ruleType: AutoRecordRuleType;
      } | null;
      readonly user: {
        readonly fullName: string;
      } | null;
    } | null>;
  };
};
export type DevMenuAutoRecordEventDataQuery = {
  response: DevMenuAutoRecordEventDataQuery$data;
  variables: DevMenuAutoRecordEventDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ruleType",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ruleLevel",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterAttendeeType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterMinimumAttendees",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterMaximumAttendees",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterKeywordsContains",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filterKeywordsRestrict",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AutoRecordRuleUser",
  "kind": "LinkedField",
  "name": "autoRecordRuleUsers",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeAllReports",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "record",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DevMenuAutoRecordEventDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DevMenuAutoRecordEventData",
            "kind": "LinkedField",
            "name": "devMenuAutoRecordEventData",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AutoRecordRule",
                "kind": "LinkedField",
                "name": "rule",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DevMenuAutoRecordEventDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DevMenuAutoRecordEventData",
            "kind": "LinkedField",
            "name": "devMenuAutoRecordEventData",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AutoRecordRule",
                "kind": "LinkedField",
                "name": "rule",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v9/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "441b32946b0db4ad7d7549fd2831c53d",
    "id": null,
    "metadata": {},
    "name": "DevMenuAutoRecordEventDataQuery",
    "operationKind": "query",
    "text": "query DevMenuAutoRecordEventDataQuery {\n  viewer {\n    devMenuAutoRecordEventData {\n      rule {\n        ruleType\n        ruleLevel\n        filterAttendeeType\n        filterMinimumAttendees\n        filterMaximumAttendees\n        filterKeywordsContains\n        filterKeywordsRestrict\n        autoRecordRuleUsers {\n          includeAllReports\n          user {\n            id\n            fullName\n            email\n          }\n        }\n        id\n      }\n      record\n      event {\n        title\n        start\n        id\n      }\n      user {\n        fullName\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "45ff28e149be1c868a02913d3772ca52";

export default node;
